<template>
  <div>
    <div class="cs-home-intro-container-image">
      <div class="cs-home-intro-row-space"></div>
      <b-container fluid="lg">
        <b-row class="cs-home-header-title-row text-center">
          <b-col>
            <span class="cs-home-header-title">{{ content.headerTitle }}</span>
          </b-col>
        </b-row>
        <b-row class="cs-home-header-title-row mt-5 pb-5 text-center">
          <b-col v-for="btn in content.buttons" v-bind:key="btn._id" col class="py-3">
            <div v-if="btn.type === 'button'">
              <b-button :class="btn.customClass" @click.stop="btnAction(btn)">
                {{ btn.description }}
                <b-img :alt="btn.alt" class="img-fluid ml-2" :src="getImagePath(btn.iconSrc)" />
              </b-button>
            </div>
            <div v-else>
              <b-img @click="btnAction(btn)" :alt="btn.alt" :class="btn.customClass"
                     :src="getImagePath(btn.iconSrc)" />
            </div>
          </b-col>
        </b-row>
      </b-container>
      <video-demonstration-modal ref="videoModal" :video-name="content.modalVideoName"/>
    </div>
  </div>
</template>

<script>
import VideoDemonstrationModal from '@/components/modals/VideoDemonstrationModal.vue';
import { getImageSrc } from '@/utils/assets';

export default {
  name: 'Intro',
  components: { VideoDemonstrationModal },
  props: {
    content: Object,
  },
  data() {
    return {};
  },
  methods: {
    btnAction(btnContent) {
      if (btnContent.id === 'videoBtn') {
        this.$refs.videoModal.videoShow = true;
      } else if (btnContent.id === 'appleStoreBtn') {
        window.location.href = btnContent.link;
        this.$gtag.event('click', {
          event_category: 'APP_PROMOTION',
          event_label: 'APPLE_STORE',
          value: '',
        });
      }
    },
    getImagePath(imageName) {
      return getImageSrc(imageName);
    },
  },
};
</script>

<style scoped lang="scss">
.cs-home-intro-container-image {
  background-image: url(../../../public/images/shauttHomePageImage.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.cs-home-intro-row-space {
  height: 125px;
  width: auto;
}

.cs-home-intro-button-video {
  background-color: #000000;
  color: $headerPrimaryColor;
  padding: 12px 20px;
  border-radius: 10px;
  height: 55px;
  border-color: grey;
  & img {
    height: 25px;
    width: 25px;
  }
  &:hover {
    opacity: 85%;
  }
}

.cs-home-intro-app-store-icon {
  height: 55px;
  &:hover {
    cursor: pointer;
    opacity: 85%;
  }
}
.cs-home-header-title-row {
  width: 50%;
}

.cs-home-header-title {
  font-size: 3vw;
  line-height: 150%;
  color: $brandSecondaryColor;
  font-weight: bold;
  text-shadow: 0.5px 0.5px;
}

@media (max-width: 1000px) {
  .cs-home-header-title {
    font-size: 3vw;
    line-height: 150%;
  }
  .cs-home-header-title-row {
    width: 80%;
  }
  .cs-home-intro-button-video {
    width: 163px;
  }
}

@media (max-width: 800px) {
  .cs-home-header-title {
    font-size: 4vw;
    line-height: 150%;
  }
  .cs-home-header-title-row {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .cs-home-header-title {
    font-size: 5vw;
  }
}

@media (max-width: 400px) {
  .cs-home-header-title {
    font-size: 6vw;
  }
}
</style>
